// API 상태 확인 및 AI 호출 헬퍼 (OpenRouter 백엔드 프록시)
//
// 프론트엔드는 더 이상 LLM 키를 직접 보유하지 않습니다.
// 모든 호출은 백엔드 /api/ai/chat 을 거쳐 OpenRouter로 전달됩니다.

const getBackendBaseUrl = () =>
  process.env.REACT_APP_BACKEND_URL || process.env.REACT_APP_SERVER_URL || '';

/**
 * 백엔드 /api/ai/chat 프록시 호출.
 *
 * @param {Object} params
 * @param {Array<{role: 'system'|'user'|'assistant', content: string}>} params.messages
 * @param {string} [params.model]
 * @param {string} [params.fallbackModel]
 * @param {number} [params.temperature]
 * @param {number} [params.maxTokens]
 * @param {Object} [params.responseFormat] - e.g. { type: 'json_object' }
 * @param {boolean} [params.useWebSearch] - true 면 모델에 :online suffix가 붙어 URL/웹 페치 활성화
 * @returns {Promise<{content: string, modelUsed: string}>}
 */
export const chatCompletion = async ({
  messages,
  model,
  fallbackModel,
  temperature,
  maxTokens,
  responseFormat,
  useWebSearch,
} = {}) => {
  if (!Array.isArray(messages) || messages.length === 0) {
    throw new Error('messages must be a non-empty array');
  }

  const url = `${getBackendBaseUrl()}/api/ai/chat`;
  const res = await fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify({
      messages,
      model,
      fallbackModel,
      temperature,
      maxTokens,
      responseFormat,
      useWebSearch,
    }),
  });

  if (!res.ok) {
    let errMsg = `AI request failed: ${res.status}`;
    try {
      const data = await res.json();
      if (data?.error) errMsg = data.error;
    } catch {
      // ignore
    }
    throw new Error(errMsg);
  }

  const data = await res.json();
  if (!data?.success || !data.content) {
    throw new Error(data?.error || 'AI returned empty response');
  }
  return { content: data.content, modelUsed: data.modelUsed };
};

// ─── 레거시 호환 export ─────────────────────────────────────────────
// 과거 코드가 import 하던 함수들. 직접 키를 노출하지 않으므로 항상 null/false 반환.
// 새 코드는 위의 `chatCompletion` 을 사용하세요.

export const getGeminiApiKey = async () => null;
export const getGenAI = async () => null;
export const refreshGeminiApiKey = async () => null;
export const isGeminiKeyLoaded = () => false;

export const checkAPIStatus = async () => ({
  ai: { available: true, status: 'OpenRouter (backend proxy)' },
});

export const logAPIStatus = async () => {
  await checkAPIStatus();
};

export default checkAPIStatus;
